"use client"

import { Button } from "@/components/themes/ui/button"
import { SlidersHorizontal, ArrowUpDown } from "lucide-react"
import { motion } from "framer-motion"

type BottomMobileBarProps = {
  onOpenFilterSheet: () => void
  onOpenSortSheet: () => void
}

export default function BottomMobileBar({ onOpenFilterSheet, onOpenSortSheet }: BottomMobileBarProps) {
  return (
    <div>
      <motion.div
        className=" md:!hidden !sticky !bottom-0 bg-white border-t shadow-lg z-10 flex justify-around py-3"
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <Button variant="ghost" className="flex  items-center gap-1 text-gray_text" onClick={onOpenSortSheet}>
          <ArrowUpDown className="w-5 h-5" />
          <span className="text-xs font-medium">Sort</span>
        </Button>
        <Button variant="ghost" className="flex  items-center gap-1 text-gray_text" onClick={onOpenFilterSheet}>
          <SlidersHorizontal className="w-5 h-5" />
          <span className="text-xs font-medium">Filter</span>
        </Button>
      </motion.div>
    </div>
  )
}